import {Storage} from "@/services/Storage"

export const authentication = {
    async isUserLoggedIn() {
        let user = await Storage.getCurrentUser();
        return !!user;
    },

}
